export default "__VITE_ASSET__ff7e202e__"